const t={path:"/api/v1/analytics_events",method:"POST"};export{t as AnalyticsEvent};
